// extracted by mini-css-extract-plugin
export default {"icon":"UpcomingCoursesTab_icon__6VP0a"};